import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const cityValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const city = control.value?.trim();
  const cityRegex = /^[A-Za-zÀ-ſ\s]+$/;
  return city && !cityRegex.test(city) ? { invalidCity: true } : null;
};
